import React from "react";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import Card from "@material-ui/core/Card/Card";
import ApolloRoleList from "./Apollo_RoleList";

interface RoleTopProps {
  children?: React.ReactNode;
  rows: any;
  accountgroupRoles: any;
}

const ApolloRoleTop = (props: RoleTopProps) => {

  const {children, rows, accountgroupRoles, ...other} = props;

  const classes = apollo_useStyles();

  const roleColumns = [
    {
      name: "accountgroupId",
      label: "アカウントグループID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountgroupName",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "roleName",
      label: "ロール名",
      options: {
        filter: true,
        sort: true,
      }
    },
  ];

  const roleSortOrder: MUISortOptions = {
    name: "accountgroupId",
    direction: 'asc',
  }
  const selectableRows: SelectableRows = 'none';
  const roleOptions = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_ROLE) ? undefined : roleSortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    storageKey: STORAGE_KEY.APOLLO_ROLE,
    renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
      const colspan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colspan}>
            <ApolloRoleList row={accountgroupRoles[rowMeta.dataIndex]} pageUsers={rows}/>
          </TableCell>
        </TableRow>
      );
    },
  }

  return (
    <Card className={classes.root} square variant="outlined">
      <ApolloDataTable
        title=""
        data={accountgroupRoles ? accountgroupRoles : []}
        columns={roleColumns}
        options={
          {
            ...roleOptions,
            textLabels:{
              body: {noMatch: "該当データが存在しません"}
            },
          }
        }
      />
    </Card>
  );
};

export default ApolloRoleTop;
